import React from 'react';
import PropTypes from 'prop-types';
import {EmployeeShape} from '../../common/react/Shapes';
import {PhoneNumberUtil, PhoneNumberFormat} from 'google-libphonenumber/dist/libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const EmployeeResult = props => {
  const {
    employee: {employeeId, firstName, lastName, email, phone, branches},
    onClick
  } = props;

  const phoneNumber = phoneUtil.format(phoneUtil.parse(phone, 'US'), PhoneNumberFormat.NATIONAL);

  return <div className="employee-login-result" onClick={onClick}>
    <div className="name">
      <span className="firstName">{firstName}</span> <span className="lastName">{lastName}</span>
    </div>
    <div className="customerId">{employeeId}</div>
    <div className="email">{email}</div>
    <div className="phone">{phoneNumber}</div>
  </div>;
};

EmployeeResult.propTypes = {
  employee: EmployeeShape,
  onClick: PropTypes.func
};

export default EmployeeResult;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/EmployeeResult.js
 **/